import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { loadStorefront, type Storefront } from "./api";
import { setCurrencySymbol } from "./format";

/**
 * The store as the customer display needs it: name, logo and currency (public, no sign-in).
 * Same `useTill().store` shape the display components read.
 */
const Ctx = createContext<{ store: Storefront | null | undefined }>({ store: undefined });

export function StoreProvider({ children }: { children: ReactNode }) {
  const [store, setStore] = useState<Storefront | null | undefined>(undefined);
  useEffect(() => {
    void loadStorefront().then((sf) => {
      setStore(sf);
      if (sf?.currency?.symbol) setCurrencySymbol(sf.currency.symbol);
      if (sf?.storeName) document.title = `${sf.storeName} · Welcome`;
    });
  }, []);
  return <Ctx.Provider value={{ store }}>{children}</Ctx.Provider>;
}

export const useTill = () => useContext(Ctx);
